export default `<% var linkTarget = data.openNewWin ? '_blank' : '_self'; %>
<% var routeClass = data.openNewWin ? 'non-route' : ''; %>

<li class="search-quick-links__item">
    <a class="btn btn--tiny <%= routeClass %>"
       href="<%= translator.translateUrl(data.url) %>"
       target="<%= linkTarget %>">
        <div id="sports-search-quick-links-<%= data.title.toLocaleLowerCase() %>" class="grid grid--vertical">
            <i class="search-quick-links__icon search-quick-links__icon--custom"
               style="background-image: url(<%= data.iconUrl %>)"></i>

            <p class="search-quick-links__title"><%= data.title %></p>
        </div>
    </a>
</li>`;